import { ImageLoaderCSSStyleImpl } from '../../../toolkit/imageloader/imageloadercss';

export class TuneSettingImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{
    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            // width: '131px', 
            // height: '140px',
            width:'262px', 
            height:'165px',
            borderRadius: "4px 4px 4px 4px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingimageloader.tsx